import React from 'react';
const JoinSection = () => {
  return <div className="relative mt-16 md:mt-32 mb-16 overflow-hidden min-h-[500px] md:min-h-[800px]" data-id="element-47">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full overflow-hidden" data-id="element-48">
        <div className="absolute inset-[-20%] md:inset-0 w-[140%] md:w-full h-[140%] md:h-full scale-125 md:scale-110" data-id="element-49">
          <iframe src="https://player.vimeo.com/video/1066379860?background=1&autoplay=1&loop=1&byline=0&title=0&muted=1" className="absolute inset-0 w-full h-full object-cover" allow="autoplay; fullscreen; picture-in-picture" frameBorder="0" data-id="element-50"></iframe>
        </div>
      </div>
      {/* Dark overlay with stronger opacity */}
      <div className="absolute inset-0 bg-black/80 md:bg-black/75 z-10" data-id="element-51"></div>
      {/* Gradient overlay for more depth */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent z-20" data-id="element-52"></div>
      {/* Content */}
      <div className="relative z-30 flex items-center min-h-[500px] md:min-h-[800px]" data-id="element-53">
        <div className="text-center w-full py-12 md:py-16 px-4 md:px-8" data-id="element-54">
          <div className="max-w-4xl mx-auto" data-id="element-55">
            <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold tracking-wider text-white mb-6 md:mb-8" data-id="element-56">
              JOIN THE HALL OF FAME
            </h2>
            <p className="text-base sm:text-lg md:text-2xl text-gray-200 mb-10 md:mb-16 leading-relaxed" data-id="element-57">
              Become a guest on our show for exclusive access to private events
              and our private network of founders, investors, & executives.
            </p>
            <a href="https://link.getdealflow.ai/widget/survey/b6PKmAFLQgN8WFjwoUsI?notrack=true" target="_blank" rel="noopener noreferrer" className="inline-block border-2 border-green-500 text-green-500 hover:bg-green-500 hover:text-black transition-all duration-300 px-6 md:px-12 py-3 md:py-4 text-base md:text-xl font-semibold tracking-wide backdrop-blur-sm" data-id="element-58">
              APPLY NOW
            </a>
          </div>
        </div>
      </div>
      {/* Additional decorative gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-green-500/10 via-transparent to-transparent opacity-30 z-20" data-id="element-59"></div>
    </div>;
};
export default JoinSection;